export default __webpack_public_path__ + "static/media/main.fbb5f170.mp4";